<div [appBreadcrumbLabel]="appBreadcrumbLabel || breadcrumbLabel">
	<!-- Sub-breadcrumb for clicked user -->
	@if (clickedField) {
		<div class="sub-breadcrumb">
			<div class="sub-breadcrumb-icon-container">
				<mat-icon svgIcon="sl-polygon" class="sub-breadcrumb-icon"></mat-icon>
			</div>
			<div class="sub-breadcrumb-item">{{ breadcrumbLabel }}</div>
			<div class="sub-breadcrumb-spacer">/</div>
			<div class="sub-breadcrumb-item">{{ clickedField }}</div>
		</div>
	}

	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[rowId]="rowId.bind(this)"
		firstColumnProperty="dateTime"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						#filtersButton
						style="flex: 1"
						label="Filters"
						i18n-label="@@auditLogList-filters"
						svgIcon="sl-filter"
						data-automation-id="audit-log-filters-button"
						(click)="onRefineFiltersClicked()"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Download"
						i18n-label="@@auditLogList-download"
						svgIcon="sl-download"
						data-automation-id="audit-log-download-button"
						(click)="onDownloadClicked()"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-infinite-scroll-view>
				<div #tableContainer class="table-container" (scroll)="onScroll($event)">
					@if (loadingService.isLoading(generateAuditLogLoadingKey) && !isLoadingMore && !finishedLoadingInitData) {
						<app-data-set-loading-row />
					}
					<table
						mat-table
						[dataSource]="dataSource"
						matSortActive="dateTime"
						matSortDirection="desc"
						matSort
						[hidden]="
							(loadingService.isLoading(generateAuditLogLoadingKey) || !finishedLoadingInitData) &&
							!isLoadingMore &&
							dataSource.data.length === 0
						"
					>
						<tr class="mat-row" *matNoDataRow>
							<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
								No records found.
							</td>
						</tr>

						<ng-container matColumnDef="dateTime">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-dateTime">Date & Time</th>
							<td mat-cell *matCellDef="let row">
								@if (row.dateTime) {
									<span>
										{{
											row.dateTime
												| date: 'MMM d, yyyy, h:mm a' : timeZoneService.utcOffset(row.dateTime, row.timezoneName)
										}}
										{{ row.timezoneName | abbreviatedTimezone: row.dateTime }}
									</span>
								}
								@if (!row.dateTime) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="performedByName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-performedBy">Performed By</th>
							<td mat-cell *matCellDef="let row">
								@if (getPerformedByName(row) !== '- - -') {
									<span
										class="clickable-chip"
										(click)="onPerformedByNameClicked(row)"
										[title]="'Click to filter by this user'"
									>
										{{ getPerformedByName(row) }}
									</span>
								}
								@if (getPerformedByName(row) === '- - -') {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="performedByCompany">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-fromCompany">From Company</th>
							<td mat-cell *matCellDef="let row">
								@if (row.performedByCompany) {
									<span
										class="clickable-chip"
										(click)="onPerformedByCompanyClicked(row)"
										[title]="'Click to filter by this company'"
									>
										{{ row.performedByCompany }}
									</span>
								}
								@if (!row.performedByCompany) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="user">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-user">User</th>
							<td mat-cell *matCellDef="let row">
								@if (getUserName(row) !== '- - -') {
									<span class="clickable-chip" (click)="onUserClicked(row)" [title]="'Click to filter by this user'">
										{{ getUserName(row) }}
									</span>
								}
								@if (getUserName(row) === '- - -') {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="company">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-company">Company</th>
							<td mat-cell *matCellDef="let row">
								@if (row.company) {
									<span
										class="clickable-chip"
										(click)="onCompanyClicked(row)"
										[title]="'Click to filter by this company'"
									>
										{{ row.company }}
									</span>
								}
								@if (!row.company) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="device">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-device">Device</th>
							<td mat-cell *matCellDef="let row">
								@if (row.device) {
									<span
										class="clickable-chip"
										(click)="onDeviceClicked(row)"
										[title]="'Click to filter by this device'"
									>
										{{ row.device }}
									</span>
								}
								@if (!row.device) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="deviceGroup">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-deviceGroup">Device Group</th>
							<td mat-cell *matCellDef="let row">
								@if (row.deviceGroup) {
									<span
										class="clickable-chip"
										(click)="onDeviceGroupClicked(row)"
										[title]="'Click to filter by this device group'"
									>
										{{ row.deviceGroup }}
									</span>
								}
								@if (!row.deviceGroup) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="property">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-property">Property</th>
							<td mat-cell *matCellDef="let row">
								@if (row.property) {
									<span
										class="clickable-chip"
										(click)="onPropertyClicked(row)"
										[title]="'Click to filter by this property'"
									>
										{{ row.property }}
									</span>
								}
								@if (!row.property) {
									<span>- - -</span>
								}
							</td>
						</ng-container>

						<ng-container matColumnDef="details">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@auditLogList-details">Details</th>
							<td mat-cell *matCellDef="let row">
								<!-- Show formatted chip for access grant/edit events -->
								@if (row | shouldShowFormattedChip) {
									<div>
										<app-formatted-chip
											[deviceControl]="row.deviceControl"
											[controlAssignment]="row.controlAssignment"
											[accessTypes]="row.accessTypes"
										>
											<span [innerHTML]="row.description | auditLogDetails"></span>
										</app-formatted-chip>
									</div>
								} @else {
									<span [innerHTML]="row.description | auditLogDetails"></span>
								}
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
						<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

						<!-- Loading row for infinite scroll -->
						@if (isLoadingMore) {
							<tr mat-row>
								<td [colSpan]="displayedColumns.length" style="text-align: center; padding: 1em">
									<mat-spinner diameter="25" style="display: inline-block; vertical-align: middle"></mat-spinner>
									<span style="margin-left: 1em; vertical-align: middle" i18n="@@auditLogList-loadingMore"
										>Loading more records...</span
									>
								</td>
							</tr>
						}
					</table>
				</div>
			</app-data-set-infinite-scroll-view>
		</app-data-set-content>
	</app-data-set>
</div>
